import _ from 'lodash';
import requireAll from 'javascripts/utils/requireAll';

const stores = requireAll(
  require.context(
    './stores/',
    true,
    /\.js/,
  ),
);

class Store {
  constructor() {
    Object.keys(stores).forEach((store) => {
      this[
        _.camelCase(store)
      ] = new stores[store];
    });
  }
}

export {Store};
export default new Store();
